/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { device } from 'saur_ui_library/src/Theme';
import { createGlobalStyle } from 'styled-components';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import ArcgisMap from '../map/ArcgisMap';
import { fullMapParam, contractService } from '../../utils/helpers/observer';
import { SET_LOCATION } from '../../redux/actionType';
import { useDispatch } from 'react-redux';
import ModuleComponent from './ModuleComponent';
import { fullScreen } from '../../utils/helpers/map/mapHelper';
import {
  changeColors,
  definePayload,
  getCollectionPoolsList,
  getCommunesForEcp,
  getCommunesForHydro,
  getCommunesForIndus,
  getLinearsForHydro,
  getPointsForCollectionPoolsEcp,
  getRenderProps,
} from '../../utils/helpers/module/viewComponentHelper';
import { useNavigate } from 'react-router-dom';
import SwitchButtonComponent from '../common/component/SwitchButtonComponent';
import { loaderDataComponent } from '../../utils/helper';
import { renderSwitchButtons } from '../../utils/helpers/view/detailsHelper';
import { getEcpMode } from '../../utils/helpers/view/ecpDetailHelper';
import { app_placeholder } from '../../env.placeholders';

type EcpMode = 'pr' | 'step';

const ViewComponent = (props: any) => {
  const navigate = useNavigate();
  const clicked = '#63d1b5';
  const unclicked = 'rgb(237, 242, 250)';
  const normalizedEnv = (app_placeholder.VITE_APP_ENV || '').toString().trim().toUpperCase();
  const showEcpModeTabs = import.meta.env.DEV || normalizedEnv.startsWith('DEV') || normalizedEnv.startsWith('REC');

  // Get H2S indicator name in case H2S module and force refresh
  if (props.module === 'h2s') {
    const currentIndicator = window.sessionStorage.getItem('h2s_indicator');
    if (currentIndicator !== props.option) {
      window.sessionStorage.setItem('h2s_indicator', props.option);
      // Force a small delay to ensure sessionStorage is updated before components read it
      setTimeout(() => {
        window.dispatchEvent(new Event('storage'));
      }, 100);
    }
  }

  const [fullMap, setFullMap] = useState(false);
  const dispatch = useDispatch();
  const [module, setModule] = useState(props.module);
  const [contractCode, setContractCode] = useState(
    window.sessionStorage.getItem('contractCode') || '',
  );
  const [allBc, setAllBc] = useState<any[]>([]);
  const [bcRenderer, setBcRenderer] = useState<any>({});
  const [allInseeCodesContract, setAllInseeCodesContract] = useState<any[]>([]);
  const [linearsByInseeCodeAndBc, setLinearsByInseeCodeAndBc] = React.useState<any[]>([]);
  const [extent, setExtent] = useState('');
  const [layers, setLayers] = useState([]);
  const [dilutionButtonColor, setDilutionButtonColor] = useState('#B8CCE8');
  const [sensibilityButtonColor, setSensibilityButtonColor] =
    useState('#edf2fa');
  const [h2sButtonColor, setH2sButtonColor] = useState<any>({
    IndicatorBoonLister: '#63d1b5',
    IndicatorSejourCana: '#edf2fa',
    IndicatorSejourPR: '#edf2fa',
    IndicatorAutocurage: '#edf2fa',
    IndicatorTerrain: '#edf2fa',
  });
  const [filtersToUpdateMap, setFiltersToUpdateMap] = useState({
    query: '',
    spatialFilter: null,
  });
  const [zoomToPoint, setZoomToPoint] = useState<{x: number, y: number} | null>(null);
  const [ecpMode, setEcpMode] = useState<EcpMode>(
    getEcpMode()
  );
  const [ecpPrButtonColor, setEcpPrButtonColor] = useState<string>('#63d1b5');
  const [ecpStepButtonColor, setEcpStepButtonColor] = useState<string>('#edf2fa');

  fullMapParam.getFullMapState().subscribe((show: any) => {
    setFullMap(show);
  });

  // Keep contractCode reactive: ContractPopup sets sessionStorage + notifies
  // via contractService without necessarily triggering a route change/remount.
  useEffect(() => {
    const subscription = contractService.getContract().subscribe((code: any) => {
      if (typeof code === 'string' && code.length > 0) {
        setContractCode(code);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    contractService.setContract(
      window.sessionStorage.getItem('contractCode') || '',
    );
    let endPoint = definePayload(module);
    dispatch({
      type: SET_LOCATION,
      payload: endPoint,
    });
    setModule(window.localStorage.getItem('type')!);

    // Initialize ECP mode to 'pr' when ECP module loads
    if (props.module === 'ecp') {
      const initialMode = showEcpModeTabs ? getEcpMode() : 'pr';
      window.sessionStorage.setItem('ecp_mode', initialMode);
      setEcpMode(initialMode);
      // Update button colors to match the mode
      if (initialMode === 'pr') {
        setEcpPrButtonColor(clicked);
        setEcpStepButtonColor(unclicked);
      } else {
        setEcpPrButtonColor(unclicked);
        setEcpStepButtonColor(clicked);
      }
    }

    // update option buttons
    if (props.module === 'milieu') {
      if (props.option === 'sensibility') {
        setSensibilityButtonColor(clicked);
        setDilutionButtonColor(unclicked);
      } else {
        setSensibilityButtonColor(unclicked);
        setDilutionButtonColor(clicked);
      }
    }
  });



  useEffect(() => {
    if (props.module === 'h2s') {
      switch (props.option) {
        case 'IndicatorSejourCana':
          setH2sButtonColor(changeColors(h2sButtonColor, 'IndicatorSejourCana'))
          break;
        case 'IndicatorSejourPR':
          setH2sButtonColor(changeColors(h2sButtonColor, 'IndicatorSejourPR'))
          break;
        case 'IndicatorAutocurage':
          setH2sButtonColor(changeColors(h2sButtonColor, 'IndicatorAutocurage'))
          break;
        case 'IndicatorTerrain':
          setH2sButtonColor(changeColors(h2sButtonColor, 'IndicatorTerrain'))
          break;
      
        default:setH2sButtonColor(changeColors(h2sButtonColor, 'IndicatorBoonLister'))
          break;
      }
    }
  }, [props.option]);

  // Sync ECP mode with button colors whenever ecpMode changes
  useEffect(() => {
    if (props.module === 'ecp') {
      if (ecpMode === 'pr') {
        setEcpPrButtonColor(clicked);
        setEcpStepButtonColor(unclicked);
      } else {
        setEcpPrButtonColor(unclicked);
        setEcpStepButtonColor(clicked);
      }
    }
  }, [ecpMode]);

  useEffect(() => {
    if (props.module === 'ecp') {
      console.log('[ECP][FeatureFlag] Runtime details', {
        viteDevMode: import.meta.env.DEV,
        deployEnvRaw: app_placeholder.VITE_APP_ENV,
        deployEnvNormalized: normalizedEnv,
        showEcpModeTabs,
        ecpMode,
      });
    }
  }, [props.module, normalizedEnv, showEcpModeTabs, ecpMode]);

  const getDataForEcp = async () => {
    try {
      const pointsForCollectionPools = getPointsForCollectionPoolsEcp(
        contractCode,
      );
      const getRender = getRenderProps();
      const getCommunes = getCommunesForEcp(contractCode);
      const [collectionPools, drawingInfo, communes] = await Promise.allSettled([pointsForCollectionPools, getRender, getCommunes]);
      if(collectionPools.status === 'fulfilled') {
        setAllBc(collectionPools.value);
      } else {
        console.log('Failed to get collection pools for ECP', collectionPools.reason);
        setAllBc([]);
      }
      if(drawingInfo.status === 'fulfilled') {
        setBcRenderer(drawingInfo.value.drawingInfo.renderer);
      } else {
        console.log('Failed to get renderer for ECP', drawingInfo.reason);
        setBcRenderer({});
      }
      if(communes.status === 'fulfilled') {
        setAllInseeCodesContract(communes.value);
      } else {
        console.log('Failed to get communes for ECP', communes.reason);
        setAllInseeCodesContract([]);
      }
    } catch (error) {
      console.error('Error in getDataForEcp:', error);
    }
  }

  const getDataForIndus = async () => {
    try {
      const getCommunes = getCommunesForIndus(contractCode);
      const getCollectionPools = getCollectionPoolsList(
        contractCode,
        props.module,
      );
      const [communes, collectionPools] = await Promise.allSettled([getCommunes, getCollectionPools]);
      if(communes.status === 'fulfilled') {
        setAllInseeCodesContract(communes.value);
      } else {
        console.log('Failed to get communes for INDUS');
        setAllInseeCodesContract([]);
      }
      if(collectionPools.status === 'fulfilled') {
        setAllBc(collectionPools.value);
      } else {
        console.log('Failed to get collectionPools for INDUS');
        setAllBc([]);
      }
    } catch (error) {
      console.error('Error in getDataForIndus:', error);
    }
  }

  const getDataForHydro = async () => {
    try {
      const getCommunes = getCommunesForHydro(contractCode);
      const getCollectionPools = getCollectionPoolsList(
        contractCode,
        props.module,
      );
      const [communes, collectionPools] = await Promise.allSettled([getCommunes, getCollectionPools]);
      let getCollectionPoolsData: any[] = [], getCommunesData: any[] = [];
      if(communes.status === 'fulfilled') {
        getCommunesData = communes.value;
      } else {
        console.log('Failed to get communes for HYDRO');
      }
      if(collectionPools.status === 'fulfilled') {
        getCollectionPoolsData = collectionPools.value;
      } else {
        console.log('Failed to get collectionPools for HYDRO');
      }
      return {
        allBc: getCollectionPoolsData,
        allInseeCodesContract: getCommunesData,
      };
    } catch (error) {
      console.error('Error in getDataForHydro:', error);
      return {
        allBc: [],
        allInseeCodesContract: [],
      };
    }
  }
  
  const getDataForHydroStepTwo = async (params: any) => {
    try {
      let data: any = [];
      // to get linears, we need inseecodes
      if (params.allInseeCodesContract.length !== 0) {
        const getLinears = await getLinearsForHydro(
          params.allInseeCodesContract,
        );
        data = getLinears;
      } else {
        console.log('Aucune communes remontées !');
      }

      // BC already got
      params.allBc.forEach((feat) => {
        data.push({
          type: 'bc',
          inseeCode: feat.name,
          linear: Math.round(feat.length),
        });
      });
      setLinearsByInseeCodeAndBc(data);
      setAllInseeCodesContract(params.allInseeCodesContract);
      setAllBc(params.allBc);
    } catch (error) {
      console.error('Error in getDataForHydroStepTwo:', error);
    }
  }
  
  // used to get all bc of contract
  useEffect(() => {
    const fetchData = async () => {
      if (props.module === 'ecp') {
        await getDataForEcp();
      } else if (props.module === 'indus') {
        await getDataForIndus();
      } else if (props.module === 'hydro') {
        await getDataForHydro().then( async (params: any) => {
          await getDataForHydroStepTwo(params);
        });
      }         
      // no data needed before launching table and filters for do/pr/h2s/pluie/milieu (sensibility and dilution)
    };

    if (
      window.localStorage.getItem('type') !== null 
    ) {
      console.log('launching requests...for '+props.module);
      fetchData();
    }
  }, [props.module]);

  const milieuButtons = () => {
    return <div style={{ width: '100%', justifyContent: 'center' }}>
      <SwitchButtonComponent
        module={props.module}
        buttonIds={['sensibilityButton', 'dilutionButton']}
        buttonNames={['Sensibilité', 'Dilution']}
        buttonCallback={(buttonName) =>
          changeSelectedButton(buttonName)
        }
        buttonColors={[
          sensibilityButtonColor,
          dilutionButtonColor,
        ]}
      />
    </div>;
  }

  const h2sButtons = () => {
    return <div style={{ width: '100%', justifyContent: 'center' }}>
      <SwitchButtonComponent
        module={props.module}
          buttonIds={[
            'IndicatorBoonLister',
            'IndicatorSejourCana',
            'IndicatorSejourPR',
            'IndicatorAutocurage',
            'IndicatorTerrain',
          ]}
          buttonNames={[
            'Boon&Lister',
            'Tps séjour cana',
            'Tps séjour PR',
            'Vit autocurage',
            'Terrain',
          ]}
          buttonCallback={(buttonName) =>
            changeSelectedButton(buttonName)
          }
          buttonColors={h2sButtonColor}
        />
    </div>
  }

  const ecpButtons = () => {
    return <div style={{ width: '100%', justifyContent: 'center' }}>
      <SwitchButtonComponent
        module={props.module}
        buttonIds={['ecpPrButton', 'ecpStepButton']}
        buttonNames={['PR', 'STEP']}
        buttonCallback={(buttonName) => changeSelectedButton(buttonName)}
        buttonColors={[ecpPrButtonColor, ecpStepButtonColor]}
      />
    </div>;
  }

  const changeSelectedButton = (pId: string) => {
    let routeToGo = '';
    if (props.module === 'ecp') {
      if (pId === 'PR') {
        setEcpMode('pr');
        setEcpPrButtonColor(clicked);
        setEcpStepButtonColor(unclicked);
        window.sessionStorage.setItem('ecp_mode', 'pr');
      } else if (pId === 'STEP') {
        setEcpMode('step');
        setEcpPrButtonColor(unclicked);
        setEcpStepButtonColor(clicked);
        window.sessionStorage.setItem('ecp_mode', 'step');
      }
      arcgisUpdate(filtersToUpdateMap.query, filtersToUpdateMap.spatialFilter);
      return; // Exit early for ECP, no navigation
    }
    if (props.module === 'milieu') {
      if (pId === 'Sensibilité') {
        routeToGo = 'MilieuSensibility';
      } else {
        routeToGo = 'MilieuDilution';
      }
    }
    if (props.module === 'h2s') {
      switch (pId) {
        case 'IndicatorSejourCana':
          routeToGo = 'IndicatorSejourCana';
          break;
        case 'IndicatorSejourPR':
          routeToGo = 'IndicatorSejourPR';
          break;
        case 'IndicatorAutocurage':
          routeToGo ='IndicatorAutocurage';
          break;
        case 'IndicatorTerrain':
          routeToGo = 'IndicatorTerrain';
          break;
        default:
          routeToGo = 'IndicatorBoonLister';
      }
    }

    if (routeToGo !== '') {
      navigate(`/${routeToGo}`);
      arcgisUpdate(filtersToUpdateMap.query, filtersToUpdateMap.spatialFilter);
    }
  };

  // get current extent for TableHYDRO component
  const getExtent = (pExtent: any) => {
    setExtent(pExtent);
  };

  const getLayers = (pLayers: any) => {
    setLayers(pLayers);
  };

  const arcgisUpdate = async (query: string, spatialFilter: any): Promise<void> => {
    setFiltersToUpdateMap({query, spatialFilter});
  };

  const zoomToPointTrigger = (point: {x: number, y: number}) => {
    setZoomToPoint(point);
  };

  return (
    <Container className='filterScreen'>
      <Styles />
      {contractCode.length > 0 && 
        <Container
          className={
            fullMap
              ? 'filterScreen-fullmap-content'
              : 'filterScreen-main-content'
          }
        >
          {/* Module */}
          <Container className='LeftPanelRow'>
            {contractCode.length > 0 && (
              <div style={{ display: fullScreen(fullMap) }}>
                {props.module === 'milieu' && milieuButtons()}
                {props.module === 'h2s' && h2sButtons()}
                {props.module === 'ecp' && showEcpModeTabs && ecpButtons()}
                {layers.length !== 0 &&
                  <ModuleComponent
                    module={props.module}
                    allBc={allBc}
                    allInseeCodesContract={allInseeCodesContract}
                    extent={extent}
                    linears={linearsByInseeCodeAndBc}
                    layers={layers}
                    option={props.option}
                    arcgisUpdate={arcgisUpdate}
                    zoomToPointTrigger={zoomToPointTrigger}
                  />}
              </div>
            )}
            <div className='sds-reset-style' style={{ display: 'flex', alignItems: 'center', width: '100%', height: layers.length === 0 ? '100vh' : '100%', justifyContent: 'center' }}>
              {loaderDataComponent(layers.length === 0 ? true : false)}
            </div>
        </Container>
        {/* Map component */}
        <div className='RightPanelRow'>
          <ArcgisMap 
            getLayers={getLayers} 
            getExtent={getExtent}
            option={props.option}
            module={props.module}
            bcRenderer={bcRenderer}
            filters={filtersToUpdateMap}
            zoomToPoint={zoomToPoint!}
          />
        </div>
      </Container>
      }
    </Container>
  );
};

const Styles = createGlobalStyle`
  .filterScreen{
    margin-left: 16%;
    width: 84%;
  canvas{
    border-radius:30px;
  }
  .filterScreen-main-content {
    margin-top: 10px;
    display: inline-flex;
    .LeftPanelRow{ 
      position: relative;
      @media ${device.mobile} {
        width: 100%;
        height: 51px;
      }
      @media ${device.tablet} {
        width: 41vw;
        height: 100%;
      }
      .hide-table-pr,.hide-table-do{ 
        display: none;
      }
      .note-style{
        font-size: 12px;
      }
    }
    .RightPanelRow{  
      position: relative;
      @media ${device.mobile} {
        width: 100%;
        height: 51px;
      }
      @media ${device.tablet} {
        margin-left:1vw;
        width: 41vw;
        height: 100%;
      }
    }
  }   
}
`;

export default ViewComponent;
